namespace TabAurous.OMS {
    declare namespace PermissionKeys {

        namespace Admin {
            export const User = "Administration:Security";
            export const Role = "Administration:Security";
            export const Permissions = "Administration:Security";
            export const Languages = "Administration:Languages";
            export const Translation = "Administration:Translation";
            export const Upload = "Administration:Upload";
            export const Security = "Administration:Security";

            namespace FormatMaster {
                export const View = "Administration:Format Master:View";
                export const Create = "Administration:Format Master:Add";
                export const Edit = "Administration:Format Master:Edit";
                export const Delete = "Administration:Format Master:Delete";
            }
        }

        namespace AccountGroup {
            export const View = "Masters:AccountGroup:View";
            export const Create = "Masters:AccountGroup:Add";
            export const Edit = "Masters:AccountGroup:Edit";
            export const Delete = "Masters:AccountGroup:Delete";
        }

        namespace Currency {
            export const View = "Masters:Currency:View";
            export const Create = "Masters:Currency:Add";
            export const Edit = "Masters:Currency:Edit";
            export const Delete = "Masters:Currency:Delete";
        }

        namespace ExchangeRate {
            export const View = "Masters:ExchangeRate:View";
            export const Create = "Masters:ExchangeRate:Add";
            export const Edit = "Masters:ExchangeRate:Edit";
            export const Delete = "Masters:ExchangeRate:Delete";
        }

        namespace FinancialYear {
            export const View = "Masters:FinancialYear:View";
            export const Create = "Masters:FinancialYear:Add";
            export const Edit = "Masters:FinancialYear:Edit";
            export const Delete = "Masters:FinancialYear:Delete";
        }

        namespace Department {
            export const View = "Masters:Department:View";
            export const Create = "Masters:Department:Add";
            export const Edit = "Masters:Department:Edit";
            export const Delete = "Masters:Department:Delete";
        }

        namespace GiftVoucher {
            export const View = "Masters:GiftVoucher:View";
            export const Create = "Masters:GiftVoucher:Add";
            export const Edit = "Masters:GiftVoucher:Edit";
            export const Delete = "Masters:GiftVoucher:Delete";
        }

        namespace HSN {
            export const View = "Masters:HSN:View";
            export const Create = "Masters:HSN:Add";
            export const Edit = "Masters:HSN:Edit";
            export const Delete = "Masters:HSN:Delete";
        }

        namespace PaymentMode {
            export const View = "Masters:PaymentMode:View";
            export const Create = "Masters:PaymentMode:Add";
            export const Edit = "Masters:PaymentMode:Edit";
            export const Delete = "Masters:PaymentMode:Delete";
        }

        namespace ProcessMaster {
            export const View = "Masters:ProcessMaster:View";
            export const Create = "Masters:ProcessMaster:Add";
            export const Edit = "Masters:ProcessMaster:Edit";
            export const Delete = "Masters:ProcessMaster:Delete";
        }

        namespace POSCustomer {
            export const View = "Masters:POSCustomer:View";
            export const Create = "Masters:POSCustomer:Add";
            export const Edit = "Masters:POSCustomer:Edit";
            export const Delete = "Masters:POSCustomer:Delete";
        }

        namespace Promotion {
            export const View = "Masters:Promotion:View";
            export const Create = "Masters:Promotion:Add";
            export const Edit = "Masters:Promotion:Edit";
            export const Delete = "Masters:Promotion:Delete";
        }

        namespace Rewards {
            export const View = "Masters:Rewards:View";
            export const Create = "Masters:Rewards:Add";
            export const Edit = "Masters:Rewards:Edit";
            export const Delete = "Masters:Rewards:Delete";
        }

        namespace Tax {
            export const View = "Masters:Tax:View";
            export const Create = "Masters:Tax:Add";
            export const Edit = "Masters:Tax:Edit";
            export const Delete = "Masters:Tax:Delete";
        }

        namespace DiscountingPolicy {
            export const View = "Masters:DiscountingPolicy:View";
            export const Create = "Masters:DiscountingPolicy:Add";
            export const Edit = "Masters:DiscountingPolicy:Edit";
            export const Delete = "Masters:DiscountingPolicy:Delete";
        }

        namespace Company {
            export const View = "Company:View";
            export const Create = "Company:Add";
            export const Edit = "Company:Edit";
            export const Delete = "Company:Delete";
        }

        namespace Customer {
            export const View = "Customer:View";
            export const Create = "Customer:Add";
            export const Edit = "Customer:Edit";
            export const Delete = "Customer:Delete";
        }

        namespace Vendor {
            export const View = "Vendor:View";
            export const Create = "Vendor:Add";
            export const Edit = "Vendor:Edit";
            export const Delete = "Vendor:Delete";
        }

        namespace Target {
            export const View = "Target:View";
            export const Create = "Target:Add";
            export const Edit = "Target:Edit";
            export const Delete = "Target:Delete";
        }

        namespace Product {
        }

        namespace Products {
            export const View = "Products:View";
            export const Create = "Products:Add";
            export const Edit = "Products:Edit";
            export const Delete = "Products:Delete";
        }

        namespace Designs {
            export const View = "Designs:View";
            export const Create = "Designs:Add";
            export const Edit = "Designs:Edit";
            export const Delete = "Designs:Delete";
        }

        namespace ToDo {
            export const View = "ToDo:View";
            export const Create = "ToDo:Add";
            export const Edit = "ToDo:Edit";
            export const Delete = "ToDo:Delete";
        }

        namespace Category {
            export const View = "Product:Category:View";
            export const Create = "Product:Category:Add";
            export const Edit = "Product:Category:Edit";
            export const Delete = "Product:Category:Delete";
        }

        namespace SubCategory {
            export const View = "Product:SubCategory:View";
            export const Create = "Product:SubCategory:Add";
            export const Edit = "Product:SubCategory:Edit";
            export const Delete = "Product:SubCategory:Delete";
        }

        namespace Attribute {
            export const View = "Product:Attribute:View";
            export const Create = "Product:Attribute:Add";
            export const Edit = "Product:Attribute:Edit";
            export const Delete = "Product:Attribute:Delete";
        }

        namespace Brand {
            export const View = "Product:Brand:View";
            export const Create = "Product:Brand:Add";
            export const Edit = "Product:Brand:Edit";
            export const Delete = "Product:Brand:Delete";
        }

        namespace Collection {
            export const View = "Product:Collection:View";
            export const Create = "Product:Collection:Add";
            export const Edit = "Product:Collection:Edit";
            export const Delete = "Product:Collection:Delete";
        }

        namespace Order {
            export const View = "Order:View";
            export const Create = "Order:Add";
            export const Edit = "Order:Edit";
            export const Delete = "Order:Delete";
        }

        namespace Services {
            export const View = "Services:View";
            export const Create = "Services:Add";
            export const Edit = "Services:Edit";
            export const Delete = "Services:Delete";
        }

        namespace Denomination {
            export const View = "Masters:Denomination:View";
            export const Create = "Masters:Denomination:Add";
            export const Edit = "Masters:Denomination:Edit";
            export const Delete = "Masters:Denomination:Delete";
        }

        namespace MarkupPolicy {
            export const View = "Masters:MarkupPolicy:View";
            export const Create = "Masters:MarkupPolicy:Add";
            export const Edit = "Masters:MarkupPolicy:Edit";
            export const Delete = "Masters:MarkupPolicy:Delete";
        }

        namespace PurchaseInvoice {
            export const View = "Purchase:Invoice:View";
            export const Create = "Purchase:Invoice:Add";
            export const Edit = "Purchase:Invoice:Edit";
            export const Delete = "Purchase:Invoice:Delete";
            export const Posting = "Purchase:Invoice:Posting";
        }

        namespace PurchaseReturn {
            export const View = "Purchase:Return:View";
            export const Create = "Purchase:Return:Add";
            export const Edit = "Purchase:Return:Edit";
            export const Delete = "Purchase:Return:Delete";
            export const Posting = "Purchase:Return:Posting";
        }

        namespace ApprovalIn {
            export const View = "Purchase:Apprroval:View";
            export const Create = "Purchase:Apprroval:Add";
            export const Edit = "Purchase:Apprroval:Edit";
            export const Delete = "Purchase:Apprroval:Delete";
            export const Posting = "Purchase:Apprroval:Posting";
        }

        namespace ApprovalInReturn {
            export const View = "Purchase:ApprrovalReturn:View";
            export const Create = "Purchase:ApprrovalReturn:Add";
            export const Edit = "Purchase:ApprrovalReturn:Edit";
            export const Delete = "Purchase:ApprrovalReturn:Delete";
            export const Posting = "Purchase:ApprrovalReturn:Posting";
        }

        namespace UnfixPurchase {
            export const View = "Purchase:UnfixPurchase:View";
            export const Create = "Purchase:UnfixPurchase:Add";
            export const Edit = "Purchase:UnfixPurchase:Edit";
            export const Delete = "Purchase:UnfixPurchase:Delete";
            export const Posting = "Purchase:UnfixPurchase:Posting";
        }

        namespace UnfixPurchaseReturn {
            export const View = "Purchase:UnfixPurchaseReturn:View";
            export const Create = "Purchase:UnfixPurchaseReturn:Add";
            export const Edit = "Purchase:UnfixPurchaseReturn:Edit";
            export const Delete = "Purchase:UnfixPurchaseReturn:Delete";
            export const Posting = "Purchase:UnfixPurchaseReturn:Posting";
        }

        namespace MaterialIn {
            export const View = "Purchase:Material:View";
            export const Create = "Purchase:Material:Add";
            export const Edit = "Purchase:Material:Edit";
            export const Delete = "Purchase:Material:Delete";
            export const Posting = "Purchase:Material:Posting";
        }

        namespace PurchaseRateFixing {
            export const View = "Purchase:RateFixing:View";
            export const Create = "Purchase:RateFixing:Add";
            export const Edit = "Purchase:RateFixing:Edit";
            export const Delete = "Purchase:RateFixing:Delete";
            export const Posting = "Purchase:RateFixing:Posting";
        }

        namespace PurchaseOrder {
            export const View = "Purchase:Purchase Order:View";
            export const Create = "Purchase:Purchase Order:Add";
            export const Edit = "Purchase:Purchase Order:Edit";
            export const Delete = "Purchase:Purchase Order:Delete";
            export const Posting = "Purchase:Purchase Order:Posting";
        }

        namespace PurchaseQuotation {
            export const View = "Retail:PurchaseQuotation:View";
            export const Create = "Retail:PurchaseQuotation:Add";
            export const Edit = "Retail:PurchaseQuotation:Edit";
            export const Delete = "Retail:PurchaseQuotation:Delete";
            export const Posting = "Purchase:PurchaseQuotation:Posting";
        }

        namespace SalesInvoice {
            export const View = "Sales:Invoice:View";
            export const Create = "Sales:Invoice:Add";
            export const Edit = "Sales:Invoice:Edit";
            export const Delete = "Sales:Invoice:Delete";
            export const Posting = "Sales:Invoice:Posting";
        }

        namespace SalesOrder {
            export const View = "Sales:Order:View";
            export const Create = "Sales:Order:Add";
            export const Edit = "Sales:Order:Edit";
            export const Delete = "Sales:Order:Delete";
            export const Posting = "Sales:Order:Posting";
        }

        namespace SalesQuotation {
            export const View = "Sales:Quotation:View";
            export const Create = "Sales:Quotation:Add";
            export const Edit = "Sales:Quotation:Edit";
            export const Delete = "Sales:Quotation:Delete";
            export const Posting = "Sales:Quotation:Posting";
        }

        namespace SalesReturn {
            export const View = "Sales:Return:View";
            export const Create = "Sales:Return:Add";
            export const Edit = "Sales:Return:Edit";
            export const Delete = "Sales:Return:Delete";
            export const Posting = "Sales:Return:Posting";
        }

        namespace ApprovalOut {
            export const View = "Sales:Approval:View";
            export const Create = "Sales:Approval:Add";
            export const Edit = "Sales:Approval:Edit";
            export const Delete = "Sales:Approval:Delete";
            export const Posting = "Sales:Approval:Posting";
        }

        namespace ApprovalOutReturn {
            export const View = "Sales:ApprovalReturn:View";
            export const Create = "Sales:ApprovalReturn:Add";
            export const Edit = "Sales:ApprovalReturn:Edit";
            export const Delete = "Sales:ApprovalReturn:Delete";
            export const Posting = "Sales:ApprovalReturn:Posting";
        }

        namespace UnfixSales {
            export const View = "Sales:Unfix:View";
            export const Create = "Sales:Unfix:Add";
            export const Edit = "Sales:Unfix:Edit";
            export const Delete = "Sales:Unfix:Delete";
            export const Posting = "Sales:Unfix:Posting";
        }

        namespace UnfixSalesReturn {
            export const View = "Sales:UnfixReturn:View";
            export const Create = "Sales:UnfixReturn:Add";
            export const Edit = "Sales:UnfixReturn:Edit";
            export const Delete = "Sales:UnfixReturn:Delete";
            export const Posting = "Sales:UnfixReturn:Posting";
        }

        namespace MaterialOut {
            export const View = "Sales:Material:View";
            export const Create = "Sales:Material:Add";
            export const Edit = "Sales:Material:Edit";
            export const Delete = "Sales:Material:Delete";
            export const Posting = "Sales:Material:Posting";
        }

        namespace SalesRateFixing {
            export const View = "Sales:RateFixing:View";
            export const Create = "Sales:RateFixing:Add";
            export const Edit = "Sales:RateFixing:Edit";
            export const Delete = "Sales:RateFixing:Delete";
            export const Posting = "Sales:RateFixing:Posting";
        }

        namespace CustomerRequirement {
            export const View = "ProductDevelopment:CustomerRequirement:View";
            export const Create = "ProductDevelopment:CustomerRequirement:Add";
            export const Edit = "ProductDevelopment:CustomerRequirement:Edit";
            export const Delete = "ProductDevelopment:CustomerRequirement:Delete";
            export const Posting = "ProductDevelopment:CustomerRequirement:Posting";
        }

        namespace Requirement {
            export const View = "ProductDevelopment:Requirement:View";
            export const Create = "ProductDevelopment:Requirement:Add";
            export const Edit = "ProductDevelopment:Requirement:Edit";
            export const Delete = "ProductDevelopment:Requirement:Delete";
            export const Posting = "ProductDevelopment:Requirement:Posting";
        }

        namespace SpecSheet {
            export const View = "ProductDevelopment:SpecSheet:View";
            export const Create = "ProductDevelopment:SpecSheet:Add";
            export const Edit = "ProductDevelopment:SpecSheet:Edit";
            export const Delete = "ProductDevelopment:SpecSheet:Delete";
            export const Posting = "ProductDevelopment:SpecSheet:Posting";
        }

        namespace DeliveryChallan {
            export const View = "Sales:DeliveryChallan:View";
            export const Create = "Sales:DeliveryChallan:Add";
            export const Edit = "Sales:DeliveryChallan:Edit";
            export const Delete = "Sales:DeliveryChallan:Delete";
            export const Posting = "Sales:DeliveryChallan:Posting";
        }

        namespace DesignRequest {
            export const View = "ProductDevelopment:DesignRequest:View";
            export const Create = "ProductDevelopment:DesignRequest:Add";
            export const Edit = "ProductDevelopment:DesignRequest:Edit";
            export const Delete = "ProductDevelopment:DesignRequest:Delete";
            export const Posting = "ProductDevelopment:DesignRequest:Posting";
        }

        namespace JobWork {
            export const View = "JobWork:JobWork:View";
            export const Create = "JobWork:JobWork:Add";
            export const Edit = "JobWork:JobWork:Edit";
            export const Delete = "JobWork:JobWork:Delete";
        }

        namespace JobWorkReturn {
            export const View = "JobWork:JobWorkReturn:View";
            export const Create = "JobWork:JobWorkReturn:Add";
            export const Edit = "JobWork:JobWorkReturn:Edit";
            export const Delete = "JobWork:JobWorkReturn:Delete";
        }

        namespace BranchOut {
            export const View = "Inventory:BranchOut:View";
            export const Create = "Inventory:BranchOut:Add";
            export const Edit = "Inventory:BranchOut:Edit";
            export const Delete = "Inventory:BranchOut:Delete";
            export const Posting = "Inventory:BranchOut:Posting";
        }

        namespace BranchIn {
            export const View = "Inventory:BranchIn:View";
            export const Create = "Inventory:BranchIn:Add";
            export const Edit = "Inventory:BranchIn:Edit";
            export const Delete = "Inventory:BranchIn:Delete";
            export const Posting = "Inventory:BranchIn:Posting";
        }

        namespace BranchInTax {
            export const View = "Inventory:BranchInTax:View";
            export const Create = "Inventory:BranchInTax:Add";
            export const Edit = "Inventory:BranchInTax:Edit";
            export const Delete = "Inventory:BranchInTax:Delete";
            export const Posting = "Inventory:BranchInTax:Posting";
        }

        namespace CertificationIssue {
            export const View = "Inventory:CertificationIssue:View";
            export const Create = "Inventory:CertificationIssue:Add";
            export const Edit = "Inventory:CertificationIssue:Edit";
            export const Delete = "Inventory:CertificationIssue:Delete";
            export const Posting = "Inventory:CertificationIssue:Posting";
        }

        namespace CertificationReturn {
            export const View = "Inventory:CertificationReturn:View";
            export const Create = "Inventory:CertificationReturn:Add";
            export const Edit = "Inventory:CertificationReturn:Edit";
            export const Delete = "Inventory:CertificationReturn:Delete";
            export const Posting = "Inventory:CertificationReturn:Posting";
        }

        namespace ReOrder {
            export const View = "Inventory:ReOrder:View";
            export const Create = "Inventory:ReOrder:Add";
            export const Edit = "Inventory:ReOrder:Edit";
            export const Delete = "Inventory:ReOrder:Delete";
            export const Posting = "Inventory:ReOrder:Posting";
        }

        namespace LocationTransfer {
            export const View = "Inventory:LocationTransfer:View";
            export const Create = "Inventory:LocationTransfer:Add";
            export const Edit = "Inventory:LocationTransfer:Edit";
            export const Delete = "Inventory:LocationTransfer:Delete";
            export const Posting = "Inventory:LocationTransfer:Posting";
        }

        namespace MaterialPayment {
            export const View = "Inventory:MaterialPayment:View";
            export const Create = "Inventory:MaterialPayment:Add";
            export const Edit = "Inventory:MaterialPayment:Edit";
            export const Delete = "Inventory:MaterialPayment:Delete";
            export const Posting = "Inventory:MaterialPayment:Posting";
        }

        namespace MaterialReceipt {
            export const View = "Inventory:MaterialReceipt:View";
            export const Create = "Inventory:MaterialReceipt:Add";
            export const Edit = "Inventory:MaterialReceipt:Edit";
            export const Delete = "Inventory:MaterialReceipt:Delete";
            export const Posting = "Inventory:MaterialReceipt:Posting";
        }

        namespace MaterialReturn {
            export const View = "Inventory:MaterialReturn:View";
            export const Create = "Inventory:MaterialReturn:Add";
            export const Edit = "Inventory:MaterialReturn:Edit";
            export const Delete = "Inventory:MaterialReturn:Delete";
            export const Posting = "Inventory:MaterialReturn:Posting";
        }

        namespace SKUCosting {
            export const View = "Inventory:SKUCosting:View";
            export const Create = "Inventory:SKUCosting:Add";
            export const Edit = "Inventory:SKUCosting:Edit";
            export const Delete = "Inventory:SKUCosting:Delete";
            export const Posting = "Inventory:SKUCosting:Posting";
        }

        namespace SKUGeneration {
            export const View = "Inventory:SKUGeneration:View";
            export const Create = "Inventory:SKUGeneration:Add";
            export const Edit = "Inventory:SKUGeneration:Edit";
            export const Delete = "Inventory:SKUGeneration:Delete";
            export const Posting = "Inventory:SKUGeneration:Posting";
        }

        namespace SKUSplitting {
            export const View = "Inventory:SKUSplitting:View";
            export const Create = "Inventory:SKUSplitting:Add";
            export const Edit = "Inventory:SKUSplitting:Edit";
            export const Delete = "Inventory:SKUSplitting:Delete";
            export const Posting = "Inventory:SKUSplitting:Posting";
        }

        namespace SKURepricing {
            export const View = "Inventory:SKURepricing:View";
            export const Create = "Inventory:SKURepricing:Add";
            export const Edit = "Inventory:SKURepricing:Edit";
            export const Delete = "Inventory:SKURepricing:Delete";
            export const Posting = "Inventory:SKURepricing:Posting";
        }

        namespace MaterialRequest {
            export const View = "Inventory:MaterialRequest:View";
            export const Create = "Inventory:MaterialRequest:Add";
            export const Edit = "Inventory:MaterialRequest:Edit";
            export const Delete = "Inventory:MaterialRequest:Delete";
            export const Posting = "Inventory:MaterialRequest:Posting";
        }

        namespace Set {
            export const View = "Inventory:Set:View";
            export const Create = "Inventory:Set:Add";
            export const Edit = "Inventory:Set:Edit";
            export const Delete = "Inventory:Set:Delete";
            export const Posting = "Inventory:Set:Posting";
        }

        namespace OpeningStock {
            export const View = "Inventory:OpeningStock:View";
            export const Create = "Inventory:OpeningStock:Add";
            export const Edit = "Inventory:OpeningStock:Edit";
            export const Delete = "Inventory:OpeningStock:Delete";
            export const Posting = "Inventory:OpeningStock:Posting";
        }

        namespace RejectionIn {
            export const View = "Inventory:RejectionIn:View";
            export const Create = "Inventory:RejectionIn:Add";
            export const Edit = "Inventory:RejectionIn:Edit";
            export const Delete = "Inventory:RejectionIn:Delete";
            export const Posting = "Inventory:RejectionIn:Posting";
        }

        namespace Melting {
            export const View = "Inventory:Melting:View";
            export const Create = "Inventory:Melting:Add";
            export const Edit = "Inventory:Melting:Edit";
            export const Delete = "Inventory:Melting:Delete";
            export const Posting = "Inventory:Melting:Posting";
        }

        namespace MeltingReturn {
            export const View = "Inventory:MeltingReturn:View";
            export const Create = "Inventory:MeltingReturn:Add";
            export const Edit = "Inventory:MeltingReturn:Edit";
            export const Delete = "Inventory:MeltingReturn:Delete";
            export const Posting = "Inventory:MeltingReturn:Posting";
        }

        namespace MRP {
            export const View = "Inventory:MRP:View";
            export const Create = "Inventory:MRP:Add";
            export const Edit = "Inventory:MRP:Edit";
            export const Delete = "Inventory:MRP:Delete";
            export const Posting = "Inventory:MRP:Posting";
        }

        namespace Sorting {
            export const View = "Inventory:Sorting:View";
            export const Create = "Inventory:Sorting:Add";
            export const Edit = "Inventory:Sorting:Edit";
            export const Delete = "Inventory:Sorting:Delete";
            export const Posting = "Inventory:Sorting:Posting";
        }

        namespace Mixing {
            export const View = "Inventory:Mixing:View";
            export const Create = "Inventory:Mixing:Add";
            export const Edit = "Inventory:Mixing:Edit";
            export const Delete = "Inventory:Mixing:Delete";
            export const Posting = "Inventory:Mixing:Posting";
        }

        namespace StockAllocation {
            export const View = "Inventory:StockAllocation:View";
            export const Create = "Inventory:StockAllocation:Add";
            export const Edit = "Inventory:StockAllocation:Edit";
            export const Delete = "Inventory:StockAllocation:Delete";
            export const Posting = "Inventory:StockAllocation:Posting";
        }

        namespace ConvertToWIP {
            export const View = "Inventory:ConvertToWIP:View";
            export const Create = "Inventory:ConvertToWIP:Add";
            export const Edit = "Inventory:ConvertToWIP:Edit";
            export const Delete = "Inventory:ConvertToWIP:Delete";
            export const Posting = "Inventory:ConvertToWIP:Posting";
        }

        namespace Repair {
            export const View = "Inventory:Repair:View";
            export const Create = "Inventory:Repair:Add";
            export const Edit = "Inventory:Repair:Edit";
            export const Delete = "Inventory:Repair:Delete";
            export const Posting = "Inventory:Repair:Posting";
        }

        namespace LotCreation {
            export const View = "Inventory:LotCreation:View";
            export const Create = "Inventory:LotCreation:Add";
            export const Edit = "Inventory:LotCreation:Edit";
            export const Delete = "Inventory:LotCreation:Delete";
            export const Posting = "Inventory:LotCreation:Posting";
        }

        namespace Quotation {
            export const View = "Retail:Quotation:View";
            export const Create = "Retail:Quotation:Add";
            export const Edit = "Retail:Quotation:Edit";
            export const Delete = "Retail:Quotation:Delete";
            export const Posting = "Retail:Quotation:Posting";
        }

        namespace POSOrders {
            export const View = "Retail:POSOrders:View";
            export const Create = "Retail:POSOrders:Add";
            export const Edit = "Retail:POSOrders:Edit";
            export const Delete = "Retail:POSOrders:Delete";
            export const Posting = "Retail:POSOrders:Posting";
        }

        namespace POSSales {
            export const View = "Retail:POSSales:View";
            export const Create = "Retail:POSSales:Add";
            export const Edit = "Retail:POSSales:Edit";
            export const Delete = "Retail:POSSales:Delete";
            export const Posting = "Retail:POSSales:Posting";
        }

        namespace POSReturn {
            export const View = "Retail:POSReturn:View";
            export const Create = "Retail:POSReturn:Add";
            export const Edit = "Retail:POSReturn:Edit";
            export const Delete = "Retail:POSReturn:Delete";
            export const Posting = "Retail:POSReturn:Posting";
        }

        namespace Exchange {
            export const View = "Retail:Exchange:View";
            export const Create = "Retail:Exchange:Add";
            export const Edit = "Retail:Exchange:Edit";
            export const Delete = "Retail:Exchange:Delete";
            export const Posting = "Retail:Exchange:Posting";
        }

        namespace RetailOrder {
            export const View = "Retail:RetailOrder:View";
            export const Create = "Retail:RetailOrder:Add";
            export const Edit = "Retail:RetailOrder:Edit";
            export const Delete = "Retail:RetailOrder:Delete";
            export const Posting = "Retail:RetailOrder:Posting";
        }

        namespace RetailQuotation {
            export const View = "Retail:RetailQuotation:View";
            export const Create = "Retail:RetailQuotation:Add";
            export const Edit = "Retail:RetailQuotation:Edit";
            export const Delete = "Retail:RetailQuotation:Delete";
            export const Posting = "Retail:RetailQuotation:Posting";
        }

        namespace GiftVoucherIssue {
            export const View = "Retail:GiftVoucherIssue:View";
            export const Create = "Retail:GiftVoucherIssue:Add";
            export const Edit = "Retail:GiftVoucherIssue:Edit";
            export const Delete = "Retail:GiftVoucherIssue:Delete";
            export const Posting = "Retail:GiftVoucherIssue:Posting";
        }

        namespace GiftVoucherAllocation {
            export const View = "Retail:GiftVoucherAllocation:View";
            export const Create = "Retail:GiftVoucherAllocation:Add";
            export const Edit = "Retail:GiftVoucherAllocation:Edit";
            export const Delete = "Retail:GiftVoucherAllocation:Delete";
            export const Posting = "Retail:GiftVoucherAllocation:Posting";
        }

        namespace GiftVoucherSales {
            export const View = "Retail:GiftVoucherSales:View";
            export const Create = "Retail:GiftVoucherSales:Add";
            export const Edit = "Retail:GiftVoucherSales:Edit";
            export const Delete = "Retail:GiftVoucherSales:Delete";
            export const Posting = "Retail:GiftVoucherSales:Posting";
        }

        namespace Campaign {
            export const View = "Retail:Campaign:View";
            export const Create = "Retail:Campaign:Add";
            export const Edit = "Retail:Campaign:Edit";
            export const Delete = "Retail:Campaign:Delete";
        }

        namespace SendCampaign {
            export const View = "Retail:SendCampaign:View";
            export const Create = "Retail:SendCampaign:Add";
            export const Edit = "Retail:SendCampaign:Edit";
            export const Delete = "Retail:SendCampaign:Delete";
        }

        namespace Shipping {
            export const View = "Retail:Shipping:View";
            export const Create = "Retail:Shipping:Add";
            export const Edit = "Retail:Shipping:Edit";
            export const Delete = "Retail:Shipping:Delete";
            export const Posting = "Retail:Shipping:Posting";
        }

        namespace PickUp {
            export const View = "Retail:PickUp:View";
            export const Create = "Retail:PickUp:Add";
            export const Edit = "Retail:PickUp:Edit";
            export const Delete = "Retail:PickUp:Delete";
            export const Posting = "Retail:PickUp:Posting";
        }

        namespace Refund {
            export const View = "Retail:Refund:View";
            export const Create = "Retail:Refund:Add";
            export const Edit = "Retail:Refund:Edit";
            export const Delete = "Retail:Refund:Delete";
            export const Posting = "Retail:Refund:Posting";
        }

        namespace POSSalesWithoutTax {
            export const View = "Retail:POSSalesWithoutTax:View";
            export const Create = "Retail:POSSalesWithoutTax:Add";
            export const Edit = "Retail:POSSalesWithoutTax:Edit";
            export const Delete = "Retail:POSSalesWithoutTax:Delete";
            export const Posting = "Retail:POSSalesWithoutTax:Posting";
        }

        namespace POSApproval {
            export const View = "Retail:POSApproval:View";
            export const Create = "Retail:POSApproval:Add";
            export const Edit = "Retail:POSApproval:Edit";
            export const Delete = "Retail:POSApproval:Delete";
            export const Posting = "Retail:POSApproval:Posting";
        }

        namespace POSApprovalReturn {
            export const View = "Retail:POSApprovalReturn:View";
            export const Create = "Retail:POSApprovalReturn:Add";
            export const Edit = "Retail:POSApprovalReturn:Edit";
            export const Delete = "Retail:POSApprovalReturn:Delete";
            export const Posting = "Retail:POSApprovalReturn:Posting";
        }

        namespace Payment {
            export const View = "Finance:Payment:View";
            export const Create = "Finance:Payment:Add";
            export const Edit = "Finance:Payment:Edit";
            export const Delete = "Finance:Payment:Delete";
            export const Posting = "Finance:Payment:Posting";
        }

        namespace Receipt {
            export const View = "Finance:Receipt:View";
            export const Create = "Finance:Receipt:Add";
            export const Edit = "Finance:Receipt:Edit";
            export const Delete = "Finance:Receipt:Delete";
            export const Posting = "Finance:Receipt:Posting";
        }

        namespace Contra {
            export const View = "Finance:Contra:View";
            export const Create = "Finance:Contra:Add";
            export const Edit = "Finance:Contra:Edit";
            export const Delete = "Finance:Contra:Delete";
        }

        namespace PDCClearance {
            export const View = "Finance:PDCClearance:View";
            export const Create = "Finance:PDCClearance:Add";
            export const Edit = "Finance:PDCClearance:Edit";
            export const Delete = "Finance:PDCClearance:Delete";
            export const Posting = "Finance:PDCClearance:Posting";
        }

        namespace PDCPayable {
            export const View = "Finance:PDCPayable:View";
            export const Create = "Finance:PDCPayable:Add";
            export const Edit = "Finance:PDCPayable:Edit";
            export const Delete = "Finance:PDCPayable:Delete";
            export const Posting = "Finance:PDCPayable:Posting";
        }

        namespace PDCReceivable {
            export const View = "Finance:PDCReceivable:View";
            export const Create = "Finance:PDCReceivable:Add";
            export const Edit = "Finance:PDCReceivable:Edit";
            export const Delete = "Finance:PDCReceivable:Delete";
            export const Posting = "Finance:PDCReceivable:Posting";
        }

        namespace Journal {
            export const View = "Finance:Journal:View";
            export const Create = "Finance:Journal:Add";
            export const Edit = "Finance:Journal:Edit";
            export const Delete = "Finance:Journal:Delete";
        }

        namespace Expense {
            export const View = "Finance:Expense:View";
            export const Create = "Finance:Expense:Add";
            export const Edit = "Finance:Expense:Edit";
            export const Delete = "Finance:Expense:Delete";
        }

        namespace AccountingPeriod {
            export const View = "Finance:AccountingPeriod:View";
            export const Create = "Finance:AccountingPeriod:Add";
            export const Edit = "Finance:AccountingPeriod:Edit";
            export const Delete = "Finance:AccountingPeriod:Delete";
            export const Posting = "Finance:AccountingPeriod:Posting";
        }

        namespace PeriodicClosing {
            export const View = "Finance:PeriodicClosing:View";
            export const Create = "Finance:PeriodicClosing:Add";
            export const Edit = "Finance:PeriodicClosing:Edit";
            export const Delete = "Finance:PeriodicClosing:Delete";
            export const Posting = "Finance:PeriodicClosing:Posting";
        }

        namespace ServiceInward {
            export const View = "Finance:ServiceInward:View";
            export const Create = "Finance:ServiceInward:Add";
            export const Edit = "Finance:ServiceInward:Edit";
            export const Delete = "Finance:ServiceInward:Delete";
            export const Posting = "Finance:ServiceInward:Posting";
        }

        namespace ServiceOutward {
            export const View = "Finance:ServiceOutward:View";
            export const Create = "Finance:ServiceOutward:Add";
            export const Edit = "Finance:ServiceOutward:Edit";
            export const Delete = "Finance:ServiceOutward:Delete";
            export const Posting = "Finance:ServiceOutward:Posting";
        }

        namespace OpeningBalance {
            export const View = "Finance:OpeningBalance:View";
            export const Create = "Finance:OpeningBalance:Add";
            export const Edit = "Finance:OpeningBalance:Edit";
            export const Delete = "Finance:OpeningBalance:Delete";
            export const Posting = "Finance:OpeningBalance:Posting";
        }

        namespace CustomerCategory {
            export const View = "HR:CustomerCategory:View";
            export const Create = "HR:CustomerCategory:Add";
            export const Edit = "HR:CustomerCategory:Edit";
            export const Delete = "HR:CustomerCategory:Delete";
        }

        namespace Designation {
            export const View = "HR:Designation:View";
            export const Create = "HR:Designation:Add";
            export const Edit = "HR:Designation:Edit";
            export const Delete = "HR:Designation:Delete";
        }

        namespace Employee {
            export const View = "HR:Employee:View";
            export const Create = "HR:Employee:Add";
            export const Edit = "HR:Employee:Edit";
            export const Delete = "HR:Employee:Delete";
        }

        namespace EmployeeAdvance {
            export const View = "HR:EmployeeAdvance:View";
            export const Create = "HR:EmployeeAdvance:Add";
            export const Edit = "HR:EmployeeAdvance:Edit";
            export const Delete = "HR:EmployeeAdvance:Delete";
        }

        namespace SalesPerson {
            export const View = "HR:SalesPerson:View";
            export const Create = "HR:SalesPerson:Add";
            export const Edit = "HR:SalesPerson:Edit";
            export const Delete = "HR:SalesPerson:Delete";
        }

        namespace TargetDistribution {
            export const View = "HR:TargetDistribution:View";
            export const Create = "HR:TargetDistribution:Add";
            export const Edit = "HR:TargetDistribution:Edit";
            export const Delete = "HR:TargetDistribution:Delete";
        }

        namespace Attendance {
            export const View = "HR:Attendance:View";
            export const Create = "HR:Attendance:Add";
            export const Edit = "HR:Attendance:Edit";
            export const Delete = "HR:Attendance:Delete";
        }

        namespace PayrollPeriod {
            export const View = "HR:PayrollPeriod:View";
            export const Create = "HR:PayrollPeriod:Add";
            export const Edit = "HR:PayrollPeriod:Edit";
            export const Delete = "HR:PayrollPeriod:Delete";
        }

        namespace Payroll {
            export const View = "HR:Payroll:View";
            export const Create = "HR:Payroll:Add";
            export const Edit = "HR:Payroll:Edit";
            export const Delete = "HR:Payroll:Delete";
        }

        namespace HolidayList {
            export const View = "HR:HolidayList:View";
            export const Create = "HR:HolidayList:Add";
            export const Edit = "HR:HolidayList:Edit";
            export const Delete = "HR:HolidayList:Delete";
        }

        namespace LeaveType {
            export const View = "HR:LeaveType:View";
            export const Create = "HR:LeaveType:Add";
            export const Edit = "HR:LeaveType:Edit";
            export const Delete = "HR:LeaveType:Delete";
        }

        namespace LeavePolicy {
            export const View = "HR:LeavePolicy:View";
            export const Create = "HR:LeavePolicy:Add";
            export const Edit = "HR:LeavePolicy:Edit";
            export const Delete = "HR:LeavePolicy:Delete";
        }

        namespace Scheme {
            export const View = "Scheme:Master:View";
            export const Create = "Scheme:Master:Add";
            export const Edit = "Scheme:Master:Edit";
            export const Delete = "Scheme:Master:Delete";
        }

        namespace SchemeEnrollment {
            export const View = "Scheme:Enrollment:View";
            export const Create = "Scheme:Enrollment:Add";
            export const Edit = "Scheme:Enrollment:Edit";
            export const Delete = "Scheme:Enrollment:Delete";
        }

        namespace SchemePayment {
            export const View = "Scheme:Payment:View";
            export const Create = "Scheme:Payment:Add";
            export const Edit = "Scheme:Payment:Edit";
            export const Delete = "Scheme:Payment:Delete";
        }

        namespace ECommOrders {
            export const View = "EComm:ECommOrder:View";
            export const Create = "EComm:ECommOrder:Add";
            export const Edit = "EComm:ECommOrder:Edit";
            export const Delete = "EComm:ECommOrder:Delete";
            export const Posting = "EComm:ECommOrder:Posting";
        }

        namespace ECommSales {
            export const View = "EComm:ECommSales:View";
            export const Create = "EComm:ECommSales:Add";
            export const Edit = "EComm:ECommSales:Edit";
            export const Delete = "EComm:ECommSales:Delete";
            export const Posting = "EComm:ECommSales:Posting";
        }

        namespace ECommSalesReturn {
            export const View = "EComm:ECommSalesReturn:View";
            export const Create = "EComm:ECommSalesReturn:Add";
            export const Edit = "EComm:ECommSalesReturn:Edit";
            export const Delete = "EComm:ECommSalesReturn:Delete";
            export const Posting = "EComm:ECommSalesReturn:Posting";
        }

        namespace ECommExchange {
            export const View = "EComm:ECommExchange:View";
            export const Create = "EComm:ECommExchange:Add";
            export const Edit = "EComm:ECommExchange:Edit";
            export const Delete = "EComm:ECommExchange:Delete";
            export const Posting = "EComm:ECommExchange:Posting";
        }

        namespace ECommOrder {
            export const View = "EComm:ECommOrder:View";
            export const Create = "EComm:ECommOrder:Add";
            export const Edit = "EComm:ECommOrder:Edit";
            export const Delete = "EComm:ECommOrder:Delete";
            export const Posting = "EComm:ECommOrder:Posting";
        }

        namespace ECommRepair {
            export const View = "EComm:ECommRepair:View";
            export const Create = "EComm:ECommRepair:Add";
            export const Edit = "EComm:ECommRepair:Edit";
            export const Delete = "EComm:ECommRepair:Delete";
            export const Posting = "EComm:ECommRepair:Posting";
        }

        namespace Reports {
            export const Finance = "";
            export const AccountPayable = "Reports:Finance:Account Payable";
            export const AccountReceivable = "Reports:Finance:Account Receivable";
            export const TrialBalance = "Reports:Finance:Trial Balance";
            export const BalanceSheet = "Reports:Finance:Balance Sheet";
            export const CashFlow = "Reports:Finance:Cash Flow";
            export const Payments = "Reports:Finance:Payments";
            export const Contra = "Reports:Finance:Contra";
            export const Journal = "Reports:Finance:Journal";
            export const Receipts = "Reports:Finance:Receipts";
            export const PeriodicClosing = "Reports:Finance:Periodic Closing";
            export const ProfitandLoss = "Reports:Finance:Profit and Loss";
            export const StatementofAccounts = "Reports:Finance:Statement of Accounts";
            export const Stock = "";
            export const BranchIn = "Reports:Stock:Branch In";
            export const BranchOut = "Reports:Stock:Branch Out";
            export const LocationTransfer = "Reports:Stock:Location Transfer";
            export const MaterialPayment = "Reports:Stock:Material Payment";
            export const MaterialReceipt = "Reports:Stock:Material Receipt";
            export const JewelleryMovement = "Reports:Stock:Jewellery Movement";
            export const JewelleryStock = "Reports:Stock:Jewellery Stock";
            export const StoneMovement = "Reports:Stock:Stone Movement";
            export const StoneStock = "Reports:Stock:Stone Stock";
            export const MetalMovement = "Reports:Stock:Metal Movement";
            export const MetalStock = "Reports:Stock:Metal Stock";
            export const ProductPerformance = "Reports:Stock:Product Performance";
            export const StockAging = "Reports:Stock:Stock Aging";
            export const SupplierPerformance = "Reports:Stock:Supplier Performance";
            export const Purchase = "";
            export const Invoice = "Reports:Purchase:Invoice";
            export const PurchaseItems = "Reports:Purchase:Purchase Items";
            export const Return = "Reports:Purchase:Return";
            export const Consignment = "Reports:Purchase:Consignment";
            export const ConsignmentReturn = "Reports:Purchase:Consignment Return";
            export const Unfix = "Reports:Purchase:Unfix";
            export const UnfixReturn = "Reports:Purchase:Unfix Return";
            export const Order = "Reports:Purchase:Order";
            export const Quotation = "Reports:Purchase:Quotation";
            export const Retail = "";
            export const Exchange = "Reports:Retail:Exchange";
            export const FootfallAndSales = "Reports:Retail:Footfall And Sales";
            export const POSReturn = "Reports:Retail:POS Return";
            export const POSSales = "Reports:Retail:POS Sales";
            export const ProductWiseSales = "Reports:Retail:Product Wise Sales";
            export const RFM = "Reports:Retail:RFM";
            export const SalesPersonWiseSales = "Reports:Retail:Sales-Person Wise Sales";
            export const Seasonality = "Reports:Retail:Seasonality";
            export const TimeWiseSales = "Reports:Retail:Time Wise Sales";
            export const Sales = "";
            export const SalesInvoice = "Reports:Sales:Sales Invoice";
            export const SalesReturn = "Reports:Sales:Sales Return";
            export const SalesConsignment = "Reports:Sales:Consignment";
            export const SalesConsignmentReturn = "Reports:Sales:Consignment Return";
            export const SalesUnfix = "Reports:Sales:Unfix";
            export const SalesUnfixReturn = "Reports:Sales:Unfix Return";
            export const CustomerSales = "Reports:Sales:Customer Sales";
            export const CustomerSalesItemWise = "Reports:Sales:Customer Sales Item-Wise";
            export const ProductSales = "Reports:Sales:Product Sales";
            export const SalesOrder = "Reports:Sales:Sales Order";
            export const SalesQuotation = "Reports:Sales:Sales Quotation";
            export const SalesItems = "Reports:Sales:Sales Items";
            export const JobWork = "";
            export const JobWorkOrder = "Reports:Job Work:Job Work Order";
            export const JobTransaction = "Reports:Job Work:Job Transaction";
            export const Production = "";
            export const WhatIsWhere = "Reports:Production:What Is Where";
            export const BagHistory = "Reports:Job Work:Bag History";
            export const LossReport = "Reports:Job Work:Loss Report";
            export const OpenWorkOrders = "Reports:Job Work:OpenWorkOrders";
            export const IssueAgainstWorkOrder = "Reports:Job Work:IssueAgainstWorkOrder";
            export const ReceiptAgainstWorkOrder = "Reports:Job Work:ReceiptAgainstWorkOrder";
            export const WorkOrderSummary = "Reports:Job Work:WorkOrderSummary";
            export const QualityInspectionSummary = "Reports:Job Work:QualityInspectionSummary";
            export const Transaction = "";
            export const PriceBifurcation = "Reports:Transaction:Price BifurcationRow";
            export const ShortList = "Reports:Transaction:Short List";
            export const StoneBifurcation = "Reports:Transaction:Stone Bifurcation";
            export const StockBifurcation = "Reports:Transaction:Stock Bifurcation";
            export const ItemsRegister = "Reports:Transaction:Items Register";
        }

        namespace Dismantling {
            export const View = "Production:Dismantling:View";
            export const Create = "Production:Dismantling:Add";
            export const Edit = "Production:Dismantling:Edit";
            export const Delete = "Production:Dismantling:Delete";
            export const Posting = "Production:Dismantling:Posting";
        }

        namespace DismantlingReturn {
            export const View = "Production:DismantlingReturn:View";
            export const Create = "Production:DismantlingReturn:Add";
            export const Edit = "Production:DismantlingReturn:Edit";
            export const Delete = "Production:DismantlingReturn:Delete";
            export const Posting = "Production:DismantlingReturn:Posting";
        }

        namespace WorkOrder {
            export const View = "Production:WorkOrder:View";
            export const Create = "Production:WorkOrder:Add";
            export const Edit = "Production:WorkOrder:Edit";
            export const Delete = "Production:WorkOrder:Delete";
        }

        namespace MFGTransaction {
            export const View = "Production:MFGTransaction:View";
            export const Create = "Production:MFGTransaction:Add";
            export const Edit = "Production:MFGTransaction:Edit";
            export const Delete = "Production:MFGTransaction:Delete";
        }

        namespace IssueMaterial {
            export const View = "Production:IssueMaterial:View";
            export const Create = "Production:IssueMaterial:Add";
            export const Edit = "Production:IssueMaterial:Edit";
            export const Delete = "Production:IssueMaterial:Delete";
            export const Posting = "Production:IssueMaterial:Posting";
        }

        namespace JobWorkIssue {
            export const View = "Production:JobWorkIssue:View";
            export const Create = "Production:JobWorkIssue:Add";
            export const Edit = "Production:JobWorkIssue:Edit";
            export const Delete = "Production:JobWorkIssue:Delete";
        }

        namespace JobWorkReceipt {
            export const View = "Production:JobWorkReceipt:View";
            export const Create = "Production:JobWorkReceipt:Add";
            export const Edit = "Production:JobWorkReceipt:Edit";
            export const Delete = "Production:JobWorkReceipt:Delete";
        }

        namespace ReceiptMaterial {
            export const View = "Production:ReceiptMaterial:View";
            export const Create = "Production:ReceiptMaterial:Add";
            export const Edit = "Production:ReceiptMaterial:Edit";
            export const Delete = "Production:ReceiptMaterial:Delete";
        }

        namespace Production {
            export const View = "Production:Production:View";
            export const Create = "Production:Production:Add";
            export const Edit = "Production:Production:Edit";
            export const Delete = "Production:Production:Delete";
        }

        namespace TreeMaking {
            export const View = "Production:TreeMaking:View";
            export const Create = "Production:TreeMaking:Add";
            export const Edit = "Production:TreeMaking:Edit";
            export const Delete = "Production:TreeMaking:Delete";
        }

        namespace Splitting {
            export const View = "Production:Splitting:View";
            export const Create = "Production:Splitting:Add";
            export const Edit = "Production:Splitting:Edit";
            export const Delete = "Production:Splitting:Delete";
        }

        namespace Merging {
            export const View = "Production:Merging:View";
            export const Create = "Production:Merging:Add";
            export const Edit = "Production:Merging:Edit";
            export const Delete = "Production:Merging:Delete";
        }

        namespace JobWorkSettlement {
            export const View = "Production:JobWorkSettlement:View";
            export const Create = "Production:JobWorkSettlement:Add";
            export const Edit = "Production:JobWorkSettlement:Edit";
            export const Delete = "Production:JobWorkSettlement:Delete";
        }

        namespace PDQuotation {
            export const View = "PD:Quotation:View";
            export const Create = "PD:Quotation:Add";
            export const Edit = "PD:Quotation:Edit";
            export const Delete = "PD:Quotation:Delete";
            export const Posting = "PD:Quotation:Posting";
        }
    }
}
